import Vue from 'vue';
import {http} from '../../http';
import sortBy from "lodash/sortBy";
import Apps from '../../../core/Apps';
import AccessLevel from '../../../core/AccessLevel';

export default {
    state: {
        practitioners: [],
        loaded: false,
        loading: false
    },

    mutations: {
        setPractitioners(state, practitioners) {
            state.practitioners = practitioners;
        },
    },

    getters: {
        getPractitioners: (state, getters) => {
            return sortBy(state.practitioners, 'realname');
        },

        find: (state, getters) => (user) => {
            const userId = typeof user === 'object' && user !== null ? user.id : parseInt(user) || 0;

            return getters.getPractitioners.find(p => p.id === userId);
        },

        isLoaded(state, getters) {
            return state.loaded;
        },

        getCalendarPermission: (state, getters) => (user, calendar) => {
            const calendarId = typeof calendar === 'object' && calendar !== null ? calendar.id : parseInt(calendar) || 0;
            const userId = typeof user === 'object' && user !== null ? user.id : parseInt(user) || 0;
            const practitioner = getters.getPractitioners.find(p => p.id === userId);

            if (!practitioner) {
                return null;
            }

            return (practitioner.calendar_permissions || []).find(cp => cp.calendar_id === calendarId);
        },

        canUserSeeCalendar: (state, getters) => (user, calendar) => {
            const calendarPermission = getters.getCalendarPermission(user, calendar);

            return calendarPermission && calendarPermission.level.value >= AccessLevel.Show;
        },

        canUserEditCalendar: (state, getters) => (user, calendar) => {
            const calendarPermission = getters.getCalendarPermission(user, calendar);

            return calendarPermission && calendarPermission.level.value >= AccessLevel.Edit;
        },
    },

    actions: {
        loadPractitioners ({ commit, state, rootGetters }) {
            if (state.loaded || state.loading) {
                return;
            }

            state.loading = true;

            if ( ! rootGetters['apps/isAppEnabled'](Apps.UserManagement)) {
                state.loaded = true;
                state.loading = false;
                return;
            }

            http.get('/app/practitioners')
                .then(({ data }) => {
                    commit('setPractitioners', data);
                    state.loaded = true;
                    state.loading = false;
                }).catch(() => {
                    state.loading = false;
                });
        },

        reloadPractitioners({ state, dispatch }) {
            state.loaded = false;
            dispatch('loadPractitioners');
        },
    }
};
